export enum ESpinnerSize {
  ExtraSmall = "20px",
  Small = "25px",
  Medium = "50px",
  Large = "75px",
}

export enum ESpinnerType {
  Ios = "Ios",
  Circular = "Circular",
}
